import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {PartnerProductDgSearchResults} from "../models/datagrid-search-results/partner-product.dg-search-results.model";
import {PartnerProductService} from "../providers/partner-product.service";

@Injectable()
export class PartnerProductResolve implements Resolve<PartnerProductDgSearchResults> {
  constructor(private partnerProductService: PartnerProductService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<PartnerProductDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.partnerProductService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
